import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './virtualstart_styles/count.css';

export default function StartCount() {
  return (
    <>
      <Container className='mt-5 mb-5 start_count'>
        <Row>
          <Col>
            <div className="start_count_content d-flex flex-md-row flex-column justify-content-evenly text-center">
              <div>
                <p>724</p>
                <span>Projects Launched</span>
              </div>
              <div>
                <p>$93,187,985</p>
                <span>Amount</span>
              </div>
              <div>
                <p>11,265,543</p>
                <span>Participants</span>
              </div>
            </div>
          </Col>
        </Row>  
      </Container>    
    </>
  )
}